<template>
    <transition name="overlay-fade">
      <div v-if="modelValue" class="drawer-overlay" @click="closeDrawer"></div>
    </transition>
  
    <transition name="drawer-slide">
      <div v-if="modelValue" class="drawer-panel">
        
        <div class="drawer-header">
          <h2>Друзья ({{ friends.length }})</h2>
          <button class="close-btn" @click="closeDrawer">✕</button>
        </div>
  
        <div class="drawer-content">
  
          <template v-if="isLoading">
            <FriendSkeleton v-for="n in 4" :key="n" />
          </template>
  
          <template v-else-if="friends.length === 0">
            <div class="empty-state">
              <img src="../assets/empty-friends-icon.png" class="empty-icon" />
              <p>У вас пока нет друзей</p>
            </div>
          </template>
  
          <template v-else>
            <FriendItem
              v-for="friend in friends"
              :key="friend.id"
              :friend="friend"
               @select="openProfile"
            />
          </template>
  
        </div>
      </div>
    </transition>
  </template>


<script setup>
import { ref, watch } from "vue";
import { waitForAuthReady } from "../utils/auth.js";
import ConnectPlusService from "../api/ConnectPlusService.js";
import FriendItem from "./FriendDialogItem.vue";
import FriendSkeleton from "./FriendSkeleton.vue";

const props = defineProps({
  modelValue: Boolean
});

const emit = defineEmits(["update:modelValue", "select"]);

const friends = ref([]);
const isLoading = ref(false);

const closeDrawer = () => {
  emit("update:modelValue", false);
};

const fetchFriends = async () => {
  isLoading.value = true;
  try {
    friends.value = await ConnectPlusService.getFriends();
  } catch (e) {
    console.error("Ошибка загрузки друзей:", e);
  } finally {
    isLoading.value = false;
  }
};

watch(
  () => props.modelValue,
  async (opened) => {
    if (opened) {
      const user = await waitForAuthReady();
      if (user) {
        await fetchFriends();
      }
    }
  }
);

const openProfile = (friend) => {
  emit("select", friend);         
  emit("update:modelValue", false);
};

</script>

<style scoped>
  
  .drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(4px);
  z-index: 998;
}

.drawer-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 420px;
  height: 100vh;
  background: #ffffff;   /* светлая тема по умолчанию */
  box-shadow: 8px 0 30px rgba(0,0,0,0.15);
  z-index: 999;
  display: flex;
  flex-direction: column;
}

[data-theme="dark"] .drawer-panel {
  background: #1e1e1e;
  box-shadow: 8px 0 30px rgba(0,0,0,0.6);
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid var(--separator_home);
}

.drawer-header h2 {
  font-family: "Eastman-Bold", sans-serif;
  font-size: 18px;
  letter-spacing: -0.3px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: #333; /* светлая тема */
}

[data-theme="dark"] .close-btn {
  color: #ffffff;
}

.close-btn:hover {
  background: rgba(33, 115, 229, 0.1);
  transform: scale(1.05);
}

[data-theme="dark"] .close-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.empty-state {
  text-align: center;
  margin-top: 60px;
  opacity: 0.7;
}

.empty-icon {
  width: 80px;
  margin-bottom: 12px;
}

/* ✨ АНИМАЦИЯ */

.drawer-slide-enter-from {
  transform: translateX(-100%);
}
.drawer-slide-enter-to {
  transform: translateX(0);
}
.drawer-slide-leave-from {
  transform: translateX(0);
}
.drawer-slide-leave-to {
  transform: translateX(-100%);
}
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.overlay-fade-enter-from,
.overlay-fade-leave-to {
  opacity: 0;
}
.overlay-fade-enter-to,
.overlay-fade-leave-from {
  opacity: 1;
}
.overlay-fade-enter-active,
.overlay-fade-leave-active {
  transition: opacity 0.25s ease;
}
  
  </style>